<template lang="pug">
  .payment(v-if="data.step=='payment'")
    form(@submit.prevent="sendPaymentMethod")
      .payment__form
        .payment__form-block-wr(v-if="data.payment_methods", v-for="item in data.payment_methods" :key="item.id")
          .payment__form-block(@click="addActive($event)")
            .payment__form-block-img-wr
              img.payment__form-block-img(:src="item.image.path")
            input.payment__form-input(type="radio", name="payment", :id="item.id", :checked="item.checked" required)
            label.payment__form-label(:for="item.id") {{item.title}}
          .payment__form-block-description {{item.description}}
          .payment__form-block-links(v-if="item.links")
            router-link.payment__form-block-links-item(v-for="link in item.links", :key="link.id", :to="link.href", target="_blank") {{link.title}}
      .payment__btns
        router-link.payment__btn-back(to="/korzina/vash-zakaz") Назад
        button.payment__btn-next(type="submit") Далее
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/payment/payment.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
  import {CartHelpersVue} from '@/mixins/CartHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  // @ is an alias to /src
  //import Events from '@/components/events/Events.vue';

export default {
  name: 'Payment',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, CartHelpersVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {

    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {

  },

  methods: {
    addActive(event) {
      let elem = event.target;
      if($(elem).hasClass('payment__form-block-img') || $(elem).hasClass('payment__form-block-img-wr')) {
        elem = $(elem).parents('.payment__form-block');
      }
      $('.payment__form-block').removeClass('payment__form-block--active');
      $(elem).addClass('payment__form-block--active');
      $(elem).children('.payment__form-input').prop("checked", true);
      this.checkRadio();
    },

    checkRadio() {
      let $checkedElem = $('input[name=payment]:checked');
      if($checkedElem.length) {
        this.checked = true;
      }
    },

    sendPaymentMethod() {
      let $checkedElem = $('input[name=payment]:checked');
      if($checkedElem.length) {
        let params = {
          payment_method: $checkedElem.attr('id')
        };

        this.savePaymentMethod((res) => {
          if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
            this.cartStep('/korzina/podtverzhdenie');
          }
        }, params);
      }
    }
  }
}
</script>
